import { render, staticRenderFns } from "./ISPPackageTemplate.vue?vue&type=template&id=54a8142e&"
import script from "./ISPPackageTemplate.vue?vue&type=script&lang=js&"
export * from "./ISPPackageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports